var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "TcEventShow flex items-center justify-center" },
    [
      _c("div", { staticClass: "w-11/12 bg-white text-gray-900" }, [
        _c(
          "article",
          [
            _c("TcEventItem", {
              staticClass: "mb-10",
              attrs: {
                event: _vm.$props.event,
                hide_info: "false",
                subscribed: _vm.subscribed
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "w-4/6 mx-auto" }, [
              _c("div", { staticClass: "flex w-full gap-3 mb-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "transport flex-1 flex gap-2 p-3 rounded-lg items-center text-center bg-gray-100"
                  },
                  [
                    _c("TcIcon", {
                      staticClass: "rounded-full text-white h-5 w-5",
                      class: {
                        "bg-green-600": _vm.event.check_bus,
                        "bg-red-300": !_vm.event.check_bus
                      },
                      attrs: { icon: _vm.event.check_bus ? "ok" : "cross" }
                    }),
                    _vm._v(" "),
                    _c("TcIcon", {
                      staticClass: "rounded-full text-gray-900 h-5 w-5",
                      attrs: { icon: "bus" }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Guagua")])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "companions flex-1 flex gap-2 p-3 rounded-lg items-center text-center bg-gray-100"
                  },
                  [
                    _c("TcIcon", {
                      staticClass: "rounded-full text-white h-5 w-5",
                      class: {
                        "bg-green-600": _vm.event.allow_companions,
                        "bg-red-300": !_vm.event.allow_companions
                      },
                      attrs: {
                        icon: _vm.event.allow_companions ? "ok" : "cross"
                      }
                    }),
                    _vm._v(" "),
                    _c("TcIcon", {
                      staticClass: "rounded-full text-gray-900 h-5 w-5",
                      attrs: { icon: "group" }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Acompañante")])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "guests flex-1 flex gap-2 p-3 rounded-lg items-center text-center bg-gray-100"
                  },
                  [
                    _c("TcIcon", {
                      staticClass: "rounded-full text-white h-5 w-5",
                      class: {
                        "bg-green-600": _vm.event.allow_guests,
                        "bg-red-300": !_vm.event.allow_guests
                      },
                      attrs: { icon: _vm.event.allow_guests ? "ok" : "cross" }
                    }),
                    _vm._v(" "),
                    _c("TcIcon", {
                      staticClass: "rounded-full text-gray-900 h-5 w-5",
                      attrs: { icon: "group" }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Invitados")])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "observaciones py-5 px-2 mb-3 rounded-lg bg-gray-100"
                },
                [
                  _c(
                    "h3",
                    { staticClass: "flex items-center" },
                    [
                      _c("TcIcon", {
                        staticClass: "h-6 w-6 mr-3",
                        attrs: { icon: "list-ul" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "font-semibold" }, [
                        _vm._v("Observaciones")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.extra_info
                    ? _c("div", {
                        staticClass:
                          "pl-9 pr-3 mt-2 overflow-x-hidden overflow-y-auto",
                        staticStyle: { "max-height": "140px" },
                        domProps: {
                          innerHTML: _vm._s(_vm.extra_info.description)
                        }
                      })
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex w-full gap-3 mb-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "start_date flex-1 text-left rounded-lg bg-gray-100 py-3 pl-2"
                  },
                  [
                    _c(
                      "h3",
                      { staticClass: "flex items-center" },
                      [
                        _c("TcIcon", {
                          staticClass: "h-6 w-6 mr-3",
                          attrs: { icon: "calendar" }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "font-semibold" }, [
                          _vm._v("Fechas")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "pl-9 pr-3 mt-2" }, [
                      _c("div", { staticClass: "mb-2" }, [
                        _c("span", { staticClass: "font-medium" }, [
                          _vm._v("Fecha evento:")
                        ]),
                        _vm._v(" "),
                        _vm.date_time
                          ? _c("div", { staticClass: "font-bold" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.date_time.toLocaleString("es-ES", {
                                    month: "short",
                                    day: "numeric",
                                    year: "numeric"
                                  })
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.date_time
                          ? _c("div", { staticClass: "font-bold" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.date_time.toLocaleString("es-ES", {
                                    hour: "numeric",
                                    minute: "numeric",
                                    hour12: true
                                  })
                                )
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("span", { staticClass: "font-medium" }, [
                          _vm._v("Inscripción hasta:")
                        ]),
                        _vm._v(" "),
                        _vm.extra_info
                          ? _c("div", { staticClass: "font-bold" }, [
                              _vm._v(_vm._s(_vm.extra_info.end_registration))
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "amount flex-1 text-left rounded-lg bg-gray-100 py-3 pl-2"
                  },
                  [
                    _c(
                      "h3",
                      { staticClass: "flex items-center" },
                      [
                        _c("TcIcon", {
                          staticClass: "h-6 w-6 mr-3",
                          attrs: { icon: "coin" }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "font-semibold" }, [
                          _vm._v("Precio")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "pl-9 pr-3 mt-2" }, [
                      _c("div", [
                        _vm._v("Estándar: "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.event.amount.strToEuro()))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v("Desempleado: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.event.amount_for_unemployed.strToEuro())
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v("Acompañante: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.event.companions_amount.strToEuro())
                          )
                        ])
                      ])
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex w-full gap-3 mb-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "company flex-1 text-left rounded-lg bg-gray-100 flex p-3 gap-3"
                  },
                  [
                    _c("TcIcon", {
                      staticClass: "h-6 w-6",
                      attrs: { icon: "company" }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", { staticClass: "font-semibold" }, [
                        _vm._v("Empresa")
                      ]),
                      _vm._v(" "),
                      _vm.extra_info
                        ? _c("div", { staticClass: "font-light" }, [
                            _vm._v(_vm._s(_vm.extra_info.company))
                          ])
                        : _vm._e()
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "speaker flex-1 text-left rounded-lg bg-gray-100 flex p-3 gap-3"
                  },
                  [
                    _c("TcIcon", {
                      staticClass: "h-6 w-6",
                      attrs: { icon: "user-circle-solid" }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", { staticClass: "font-semibold" }, [
                        _vm._v("Ponente")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "font-light" }, [
                        _vm._v(_vm._s(_vm.event.speaker))
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "organizer flex-1 text-left rounded-lg bg-gray-100 flex p-3 gap-3"
                  },
                  [
                    _c("TcIcon", {
                      staticClass: "h-6 w-6",
                      attrs: { icon: "library" }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", { staticClass: "font-semibold" }, [
                        _vm._v("Organiza")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "font-light" }, [
                        _vm._v(_vm._s(_vm.event.host_name))
                      ])
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex w-full gap-3 mt-10 mb-5" }, [
                _c(
                  "button",
                  {
                    staticClass: "flex-1 btn-secondary btn-sm",
                    on: { click: _vm.closeModal }
                  },
                  [_vm._v("Cerrar")]
                ),
                _vm._v(" "),
                !_vm.subscribed
                  ? _c(
                      "button",
                      {
                        staticClass: "flex-1 btn-sm",
                        on: {
                          click: function($event) {
                            return _vm.subscribeEvent(_vm.event)
                          }
                        }
                      },
                      [_vm._v("Inscribirme")]
                    )
                  : _c(
                      "span",
                      {
                        staticClass:
                          "flex-1 btn-sm text-center font-bold text-green-500"
                      },
                      [_vm._v(" Ya inscrito ")]
                    )
              ])
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }